import request from '@h3/request';
import { H3 } from '@h3/types';

/** 获取钉钉签名 */
export const getDingTalkSignature = (params: unknown) =>
    request<H3.Http.Response.H3Response<{ dingTalkSignature: H3.Entry.ThirdParty.ISignature }>>('/Signature/DingTalk', {
        method: 'get',
        params: params as Record<string, unknown>,
        camelCase: true,
    });

/**
 * 分享表单到钉钉会话
 * @param schemaCode 表单编码
 * @param bizObjectId 数据id
 * @param title 分享标题
 * @param cid 会话id
 * @param text 分享摘要
 */
export function shareFormToConversation(
    schemaCode: string,
    bizObjectId: string,
    title: string,
    text: string,
    cid: string,
) {
    return request<H3.Http.Response.H3ResponseV2<void>>('/Mobile/MobileService/OnAction', {
        method: H3.Http.MethodType.POST,
        data: {
            PostData: JSON.stringify({
                ActionName: 'ShareSheet',
                SchemaCode: schemaCode,
                BizObjectId: bizObjectId,
                Title: title,
                Cid: cid,
                Text: text,
                TargetId: null,
            }),
        },
        requestType: 'form',
        disableBizError: true,
    });
}

/** 获取钉钉个人授权清单 */
export const getDingTalkUserAuthList = (suiteKey: string) => {
    const url = `/v1/sysintergration/dingtalk/userAuthRules?suiteKey=${suiteKey}`;
    return request<H3.Http.Response.H3Response<H3.ThirdParty.Response.IUserAuth[]>>(url, {
        method: 'get',
        params: {},
    });
};

// 判断是否完成个人授权
export const personalAuth = (suiteKey: string) => {
    const url = `/v1/sysintergration/dingtalk/personalAuth?suiteKey=${suiteKey}`;
    return request<H3.Http.Response.H3Response<any>>(url, {
        method: 'get',
        params: {},
    });
};

// 存储用户授权信息
export const saveUserTokenMeta = (authCode: string, suiteKey: string) => {
    const url = '/v1/sysintergration/dingtalk/saveUserTokenMeta';
    return request<H3.Http.Response.H3Response<any>>(url, {
        method: 'post',
        data: {
            AuthCode: authCode,
            SuiteKey: suiteKey,
        },
    });
};

// 更新用户手机号
export const updateUserMobile = (suiteKey: string) => {
    const url = '/v1/sysintergration/dingtalk/updateUserMobile';
    return request<H3.Http.Response.H3Response<any>>(url, {
        method: 'post',
        data: {
            SuiteKey: suiteKey,
        },
    });
};
